import ClassForm from "../class/class";
import React from "react";
import { AddAppointment } from "../appointment/addAppointment";


const AppointmentFormik = (
  <div className="pt-3 ">
    <AddAppointment />
  </div>
);

export const tabsComponent = [
  {
    id: 1,
    component: AppointmentFormik,
  },
  {
    id: 2,
    component: <ClassForm />,
  },
];

export const navTabs = [
  {
    id: 1,
    title: "Appointment",
  },
  {
    id: 2,
    title: "Class",
  },
];
export const navTabsForCourt = [
  {
    id: 1,
    title: "Private Lesson",
  },
  {
    id: 2,
    title: "Group Session",
  },
];